import { Modal, TextField } from 'melp-design/components';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'config';
import { usePredefinedToasts } from 'utils/Toast';
import { ModalProps } from 'store/modal';
import { FC } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form-latest';
import { routerHistory } from 'utils/router-history';
import { Stack } from '@mui/material';
import { SurveyType, useCreateSurvey } from 'store/surveys';

interface Values {
  name: string;
}

interface Props extends ModalProps {
  type: SurveyType;
  title: string;
}

export const CreateSurveyModal: FC<Props> = ({ closeModal, type, title }) => {
  const { t } = useTranslation();
  const predefinedToasts = usePredefinedToasts();

  const { mutate: createSurvey, isLoading: isCreating } = useCreateSurvey();

  const { control, handleSubmit } = useForm<Values>({
    defaultValues: {
      name: '',
    },
  });

  const onSubmit: SubmitHandler<Values> = (values) => {
    createSurvey(
      { name: values.name, type },
      {
        onSuccess: ({ data }) => {
          closeModal();
          predefinedToasts.success.added();
          routerHistory.push(
            `${ROUTES.surveys[type].details.replace(
              ':id',
              data.id,
            )}?guided=true`,
          );
        },
      },
    );
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Modal.Content
        title={title}
        actions={[
          {
            variant: 'neutral-outline',
            onClick: () => closeModal(),
            label: t('common.cancel'),
          },
          {
            variant: 'primary',
            label: t('common.create'),
            type: 'submit',
            disabled: isCreating,
          },
        ]}
      >
        <Stack gap={2}>
          <Controller
            name="name"
            control={control}
            render={({ field: { name, value, onChange, ref } }) => (
              <TextField
                label={t('surveys.systemName')}
                name={name}
                value={value}
                onChange={onChange}
                required
                ref={ref}
              />
            )}
          />
        </Stack>
      </Modal.Content>
    </form>
  );
};
